import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Headlines = ({ headlines1, headlines2, headlinesAd }) => {
    return (
        <div className={styles.news}>
            <Chip id="260490" type="struct" title="要闻广告">
                <div className={styles.newsZggded} />
            </Chip>
            {headlinesAd?.thumbnail && (
                <a href={headlinesAd?.url} className={styles.newsZggd} target="_blank">
                    <img className={styles.newsZggdImg} src={headlinesAd?.thumbnail} />
                </a>
            )}
            <Chip id="287345" type="recommend" title="要闻1">
                <div className={styles.news1}>
                    {headlines1.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`${styles.newsItem} ${index === 0 ? styles.newsItemStrong : ''}`}>
                                <a className={styles.newsLink} target="_blank" href={item.url}>
                                    {item.title}
                                </a>
                            </div>
                        );
                    })}
                </div>
            </Chip>
            <Chip id="287346" type="recommend" title="要闻2">
                <div className={styles.news2}>
                    {headlines2.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`${styles.newsItem} ${index === 0 ? styles.newsItemStrong : ''}`}>
                                <a className={styles.newsLink} target="_blank" href={item.url}>
                                    {item.title}
                                </a>
                            </div>
                        );
                    })}
                </div>
            </Chip>
        </div>
    );
};

Headlines.propTypes = {
    headlines1: PropTypes.array,
    headlines2: PropTypes.array,
    headlinesAd: PropTypes.object,
};

export default errorBoundary(Headlines);
